export const CollapseButtonAriaLabel = "Collapse";
export const ExpandButtonAriaLabel = "Expand";
